import { useSubscription } from "@apollo/react-hooks";
import { Card, Empty } from "antd";
import moment from "moment-timezone";
import React from "react";
import { Loader } from "../../../Components/Loader";
import { CustIcon } from "../../../Components/Svgs/Svgs";
import { UserAvatar } from "../../../Components/UserAvatar";
import { USERS_ON_LEAVE_TODAY_SUBSCRIPTION } from "../../../Graphql/subscriptions";
import Empty_EmployeeOnLeaveToday from "../../../Assets/Images/Empty/Empty_EmployeeOnLeaveToday.svg";
import "./EmployeesLeave.less";
const { REACT_APP_ASSETS_URL } = process.env;

export const EmployeesLeave = ({ userTimeZone }) => {
  const { data, loading } = useSubscription(USERS_ON_LEAVE_TODAY_SUBSCRIPTION, {
    variables: {
      user_id: localStorage.getItem("user_id"),
      todays_date: moment.tz(moment(), userTimeZone).format("YYYY-MM-DD"),
    },
    skip: !userTimeZone,
  });

  return (
    <section className="employeesLeaveSec">
      <div className="secSubTitle">
        <div className="stLeft">
          <h5>Employees on leave today</h5>
        </div>
        {/* <div className="stright">
          <small className="cursor-pointer">Show more</small>
        </div> */}
      </div>
      <div className="employeesLeave_blk">
        <Card className="employeesLeaveCard">
          {loading || !userTimeZone ? (
            <Loader />
          ) : !data || data?.user_reporting_view?.length === 0 ? (
            <Empty
              image={Empty_EmployeeOnLeaveToday}
              description="Hooray! Is any of your employee on leave today? Just keep checking this space for it."
            />
          ) : (
            <ul className="list-inline employeesLeaveList">
              {data &&
                data.user_reporting_view.map((user) => (
                  <li className="d-flex align-items-center justify-content-between myEmployeesLeave">
                    <UserAvatar
                      firstName={user.subordinate_details.first_name}
                      lastName={user.subordinate_details.last_name}
                      subtitle={
                        user.subordinate_details.user_location_maps[0]
                          .jobRoleDetails.role_name
                      }
                      src={REACT_APP_ASSETS_URL+user.subordinate_details.profile_image}
                    />
                    <div className="d-flex align-items-center profileBottom employeeLocation">
                      <CustIcon type="location" className="mr-1" />
                      <span>
                        {`${user.subordinate_details.user_location_maps[0]?.locationDetails.location_name}`}
                      </span>
                    </div>
                  </li>
                ))}
            </ul>
          )}
        </Card>
      </div>
    </section>
  );
};
